<script lang="ts">
  import * as _ from "lodash";
  import IconOld from "./IconOld.svelte";
  import IconModern from "./IconModern.svelte";

  function getDefaultClassName() {
    return "svg-icon-" + _.toLower(type || "");
  }

  export let type;
  export let width = null;
  export let height = null;
  export let className = getDefaultClassName();
  export let extraClassNames = "";
  export let onPress = null;
  export let color: string = null;
  export let fill: string = null;
  export let transform: string = null;
  export let centered = false;
  export let extraStyles: string = "";
  export let opacity = 1;
  export let id: string = null;
  export let dataTestId: string = null;
  export let useModernMode: boolean = false;

  let modernMode = window["modern_mode"] || useModernMode;

</script>

{#if modernMode}
  <IconModern
    {...{
      type,
      width,
      height,
      className,
      extraClassNames,
      onPress,
      color,
      fill,
      transform,
      centered,
      extraStyles,
      opacity,
      id,
      dataTestId,
    }}
  />
{:else}
  <IconOld
    {...{
      type,
      width,
      height,
      className,
      extraClassNames,
      onPress,
      color,
      fill,
      transform,
      centered,
      extraStyles,
      opacity,
      id,
      dataTestId,
    }}
  />
{/if}
